var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-fading-circle"},_vm._l((12),function(n){return _c('div',{key:n,class:("sk-circle" + n + " sk-circle")})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }